import {atom} from "recoil";

export const myProjectsAtom = atom({
    key: "myProjectsAtom-Key",
    default: [],
});